import Immutable from 'immutable';
import * as types from './Orders.types';

const initialState = {
    type: null,
    orders: [],
    fetching: false,
    idModal: null,
    isApproving: false,
    isRejecting: false,
    isFromEmail: false,
    pagination: {
        totalElements: 0,
        activePage: 1,
        totalPages: 0,
        elementsPerPage: 15,
    },
    exportingACMExcel: false,
    exportingUTPExcel: false,
    exportingOrder: false,
    sort: {
        column: 'approved_date',
        type: 'desc',
    },
    search: '',
    searchType: 'uthealth_order_id',
    isCheckingSCTicket: false,
    isCreatingSCTicket: false,
    ticketExists: false,
    scTicketId: null,
    trackingNumber: '',
    shipped: 0,
    shippingMethod: '',
    shippingQuantity: '',
    shippingWeight: '',
    shippingNumPackages: '',
    packingSlipMessage: '',
    packingSlipItems: [],
    isSavingShipping: false,
    savingPackingSlip: false,
    printingPackingSlip: false,
    fetchingPackingSlipData: false,
    orderProducts: [],
    scTicketSelectedItems: [],
    generatingPrintReadyFile: false,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_ORDERS:
            return state.setIn(['fetching'], true).toJS();

        case types.FETCH_ORDERS_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['orders'], action.payload.elements)
                .setIn(['pagination', 'totalElements'], action.payload.totalElements)
                .setIn(['pagination', 'activePage'], action.payload.activePage)
                .setIn(['pagination', 'totalPages'], action.payload.totalPages)
                .setIn(['pagination', 'elementsPerPage'], action.payload.elementsPerPage)
                .toJS();

        case types.FETCH_ORDERS_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.APPROVE_ORDER:
            return state.setIn(['isApproving'], true).toJS();

        case types.APPROVE_ORDER_SUCCESS:
            return state.setIn(['isApproving'], false).toJS();

        case types.APPROVE_ORDER_ERROR:
            return state.setIn(['isApproving'], false).toJS();

        case types.REJECT_ORDER:
            return state.setIn(['isRejecting'], true).toJS();

        case types.REJECT_ORDER_SUCCESS:
            return state.setIn(['isRejecting'], false).toJS();

        case types.REJECT_ORDER_ERROR:
            return state.setIn(['isRejecting'], false).toJS();

        case types.FETCH_PACKING_SLIP_DATA:
            return state.setIn(['fetchingPackingSlipData'], true).toJS();

        case types.FETCH_PACKING_SLIP_DATA_SUCCESS:
            return state.setIn(['fetchingPackingSlipData'], false)
                .setIn(['orderProducts'], action.payload.orderProducts)
                .setIn(['packingSlipItems'], action.payload.packingSlipItems)
                .toJS();

        case types.FETCH_PACKING_SLIP_DATA_ERROR:
            return state.setIn(['fetchingPackingSlipData'], false).toJS();

        case types.SET_ID_MODAL:
            return state.setIn(['idModal'], action.payload).toJS();

        case types.SET_TYPE:
            return state.setIn(['type'], action.payload).toJS();

        case types.SET_IS_FROM_EMAIL:
            return state.setIn(['isFromEmail'], action.payload).toJS();

        case types.SET_ACTIVE_PAGE:
            return state.setIn(['pagination', 'activePage'], action.payload).toJS();

        case types.EXPORT_EXCEL:
            return state.setIn(['exportingACMExcel'], action.payload === 1)
                .setIn(['exportingUTPExcel'], action.payload === 2)
                .toJS();

        case types.EXPORT_EXCEL_SUCCESS:
            return state.setIn(['exportingACMExcel'], false)
                .setIn(['exportingUTPExcel'], false)
                .toJS();

        case types.EXPORT_EXCEL_ERROR:
            return state.setIn(['exportingACMExcel'], false)
                .setIn(['exportingUTPExcel'], false)
                .toJS();

        case types.EXPORT_ORDER:
            return state.setIn(['exportingOrder'], true).toJS();

        case types.EXPORT_ORDER_SUCCESS:
            return state.setIn(['exportingOrder'], false).toJS();

        case types.EXPORT_ORDER_ERROR:
            return state.setIn(['exportingOrder'], false).toJS();

        case types.SET_SORT:
            return state.setIn(['sort', 'type'], action.payload.type)
                .setIn(['sort', 'column'], action.payload.column)
                .toJS();

        case types.SET_SEARCH:
            return state.setIn(['search'], action.payload).toJS();

        case types.SET_SEARCH_TYPE:
            return state.setIn(['searchType'], action.payload).toJS();

        case types.CHECK_SC_TICKET:
            return state.setIn(['isCheckingSCTicket'], true).toJS();

        case types.CHECK_SC_TICKET_SUCCESS:
            return state.setIn(['isCheckingSCTicket'], false)
                .setIn(['ticketExists'], action.payload.exists)
                .setIn(['scTicketId'], action.payload.scTicketId)
                .toJS();

        case types.CHECK_SC_TICKET_ERROR:
            return state.setIn(['isCheckingSCTicket'], false).toJS();

        case types.CREATE_SC_TICKET:
            return state.setIn(['isCreatingSCTicket'], true).toJS();

        case types.CREATE_SC_TICKET_SUCCESS:
            return state.setIn(['isCreatingSCTicket'], false)
                .setIn(['ticketExists'], true)
                .setIn(['scTicketId'], action.payload.id)
                .setIn(['scTicketSelectedItems'], [])
                .toJS();

        case types.CREATE_SC_TICKET_ERROR:
            return state.setIn(['isCreatingSCTicket'], false).toJS();

        case types.SAVE_PACKING_SLIP:
            return state.setIn(['savingPackingSlip'], true).toJS();

        case types.SAVE_PACKING_SLIP_SUCCESS:
            return state.setIn(['savingPackingSlip'], false).toJS();

        case types.SAVE_PACKING_SLIP_ERROR:
            return state.setIn(['savingPackingSlip'], false).toJS();

        case types.PRINT_PACKING_SLIP:
            return state.setIn(['printingPackingSlip'], true).toJS();

        case types.PRINT_PACKING_SLIP_SUCCESS:
            return state.setIn(['printingPackingSlip'], false).toJS();

        case types.PRINT_PACKING_SLIP_ERROR:
            return state.setIn(['printingPackingSlip'], false).toJS();

        case types.GENERATE_PRINT_READY_FILE:
            return state.setIn(['generatingPrintReadyFile'], true).toJS();

        case types.GENERATE_PRINT_READY_FILE_SUCCESS:
            return state.setIn(['generatingPrintReadyFile'], false)
                .updateIn(['orders'], (orders) => {
                    const newOrders = orders.toJS();
                    const index = newOrders.findIndex((order) => parseInt(action.payload.id) === parseInt(order.id));
                    newOrders[index] = action.payload;  
                    return newOrders;
                }).toJS();

        case types.GENERATE_PRINT_READY_FILE_ERROR:
            return state.setIn(['generatingPrintReadyFile'], false).toJS();

        case types.SET_TRACKING_NUMBER:
            return state.setIn(['trackingNumber'], action.payload).toJS();

        case types.SET_SHIPPED:
            return state.setIn(['shipped'], action.payload).toJS();

        case types.SET_SHIPPING_METHOD:
            return state.setIn(['shippingMethod'], action.payload).toJS();

        case types.SET_SHIPPING_QUANTITY:
            return state.setIn(['shippingQuantity'], action.payload).toJS();

        case types.SET_SHIPPING_WEIGHT:
            return state.setIn(['shippingWeight'], action.payload).toJS();

        case types.SET_SHIPPING_NUM_PACKAGES:
            return state.setIn(['shippingNumPackages'], action.payload).toJS();

        case types.SET_PACKING_SLIP_MESSAGE:
            return state.setIn(['packingSlipMessage'], action.payload).toJS();

        case types.CHECK_PACKING_SLIP_ITEM:
            return state.updateIn(['packingSlipItems'], (packingSlipItems) => {
                const items = packingSlipItems.toJS();

                let productIndex = -1;
                for (let i = 0; i < items.length; i++) {
                    if (parseInt(items[i].id) === parseInt(action.payload.id)) {
                        productIndex = i;
                        break;
                    }
                }

                if (productIndex === -1) {
                    items.push({ id: action.payload.id, items: [] });
                    productIndex = items.length - 1;
                }

                const index = items[productIndex].items.indexOf(action.payload.value);
                if (index === -1) {
                    items[productIndex].items.push(action.payload.value);
                } else {
                    items[productIndex].items.splice(index, 1);
                }

                return items;
            }).toJS();

        case types.SAVE_SHIPPING:
            return state.setIn(['isSavingShipping'], true).toJS();

        case types.SAVE_SHIPPING_SUCCESS:
            return state.setIn(['isSavingShipping'], false).toJS();

        case types.SAVE_SHIPPING_ERROR:
            return state.setIn(['isSavingShipping'], false).toJS();

        case types.SET_PACKING_SLIP_ITEMS:
            return state.setIn(['packingSlipItems'], action.payload).toJS();

        case types.CHECK_SC_TICKET_CHECKBOX:
            return state.updateIn(['scTicketSelectedItems'], (scTicketSelectedItems) => {
                const items = scTicketSelectedItems.toJS();

                const index = items.findIndex((item) => parseInt(item.id) === parseInt(action.payload.id));
                if (index === -1) {
                    items.push(action.payload);
                } else {
                    items.splice(index, 1);
                }

                return items;
            }).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}